import * as React from 'react';
import { memo } from 'react';

const SvgPlay = (props) => (React.createElement("svg", Object.assign({ width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { clipRule: "evenodd", d: "m5 3 14 9-14 9V3v0Z", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" })));
const Memo = memo(SvgPlay);

export { Memo as default };
